import React from 'react';
import classNames from 'classnames';
import styles from './404.module.scss';
import notFound from '../img/not-found.png';

const NotFoundPage = () => (
  <div className={styles.wrapper}>
    <h1 className={styles.heading}>The page you requested can't be found</h1>
    <img className={styles.image} src={notFound} />
    <a className={classNames('button is-primary', styles.button)} href="/">
      Go to Support Overview
    </a>
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js